<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ ooptObject.transName }} - {{ $t('Галерея объектов') }}</h1>
      <div class="workroom-pg">
        <div class="bgw-pdg-20 my-organization">
          <div class="add-npa-row">
            <GalleryForm
              :objectId="ooptObject.id"
            >
              &nbsp;{{ $t('Добавить') }}
            </GalleryForm>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td>№</td>
                <td>{{ $t('Описание') }}</td>
                <td>{{ $t('Изображение') }}</td>
                <td>{{ $t('Статус') }}</td>
                <td>{{ $t('Действия') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(gallery, i) in ooptObject.galleries" :key="gallery.id">
                <td>{{ ++i }}</td>
                <td>
                    <GalleryForm
                      :objectId="ooptObject.id"
                      :id="gallery.id"
                      :isEdit="true"
                    >
                      {{ gallery.transDescription }} <span class="edit-icon"></span>
                    </GalleryForm>
                </td>
                <td>
                  <v-img width="100" :src="backUrl + gallery.fullFilesDirectory"></v-img>
                </td>
                <td class="td-status">
                  <span>{{ gallery.is_active === true ? $t('Активен') : $t('Не активен') }}</span>
                </td>
                <td class="td-action">
                  <v-btn class="btn-add" @click.native.stop="deleteItem(gallery.id)">
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Gallery from '@/model/objectGallery'
import GalleryForm from '@/components/oopt/ObjectGalleryForm'

export default {
  components: { GalleryForm },
  data: () => ({
    ooptObject: {},
    breadcrumbs: [],
    backUrl: process.env.VUE_APP_BACK_URL
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Gallery.list(this.$route.params.id)
        .then((response) => {
          this.ooptObject = { ...response.data.ooptObject }
          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
            { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
            { text: this.ooptObject.ooptTransName, disabled: false, href: '/my-organization?id=' + this.ooptObject.ooptId },
            { text: this.ooptObject.transName, disabled: false, href: '/objects/' + this.ooptObject.id },
            { text: this.$i18n.t('Галерея объектов'), disabled: true }
          ]

          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    deleteItem (id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        Gallery.delete(id)
          .then((response) => {
            if (response.status === 200) {
              this.fetchData()
            }
            this.setLoading(false)
          })
          .catch((error) => {
            this.setLoading(false)
          })
      }
    }
  }
}
</script>
